<template>
  <div>

    <nav :class="{ 'navbar-hidden': !showNavbar }">

      <div><router-link to="/" exact replace>
        <div class="navbutton">
          <i class="material-icons">home</i>
          <p>Min bar</p>
        </div>
      </router-link></div>

      <div><router-link to="/ølkort" replace>
        <div class="navbutton">
          <i class="material-icons">list_alt</i>
          <p>Ølkort</p>
        </div>
      </router-link></div>

      <div><router-link to="/profil" replace>
        <div class="navbutton">
          <i class="material-icons">account_box</i>
          <p>Profil</p>
        </div>
      </router-link></div>


    </nav>
  </div>

</template>

<script>


export default {
  name: 'Navbar',
  components: {

  },
  data () {
    return {
      showNavbar: true,
      lastScrollPosition: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
  onScroll () {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
    if (currentScrollPosition < 0) {
      return
    }
    // Stop executing this function if the difference between
    // current scroll position and last scroll position is less than some offset
    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 5) {
      return
    }
    this.showNavbar = currentScrollPosition < this.lastScrollPosition
    this.lastScrollPosition = currentScrollPosition
  }
 }
}

</script>

<style scoped>

nav{
  width: 100%;
  padding: 16px;
  background-color: var(--primaryColor);
  bottom: 0;
  left: 0;
  position: fixed;
  box-sizing: border-box;
  display: flex;
  justify-content: space-space-between;
  box-shadow: 0 -4px 4px rgba(0,0,0,0.3);
  transition: transform 200ms;
}
.fab{
  transition: transform 300ms;
}
div{
  display: block;
  margin: auto;
  width: 100px;
}
.navbutton{
  margin: auto;
}
p{
  font-size: 14px;
  margin: 0;
}
a{
  color: var(--inactiveColor);
  text-decoration: inherit;
}
.router-link-active {
  color: var(--secondaryColor);
}

.navbar-hidden {
  transform: translateY(100%);
  box-shadow: none;
}
.fab-hidden{
  transform: scale(0);
}

</style>
